import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import 'babel-polyfill'

// 自定义插件
import vueInit from '@/plugins/vueInit';
Vue.use(vueInit)

// import XdvideoPlayer from '@platform/xdvideo-player-vue2';
// import '@platform/xdvideo-player-vue2/dist/xdvideo-player-vue2.css';

// Vue.use(XdvideoPlayer);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
